export const TRACE_STORE_NAME = 'trace';
export const ABS_ASSET_CLASS_ID = '4549f728-3f71-4566-b114-c8dfb3ccb261';

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PAGE = 1;
